/**
 * useCurrencies
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import CurrenciesContext from './currencies-context'

const useCurrencies = () => {
  const context = useContext(CurrenciesContext)
  return context
}

export default useCurrencies
